import { z } from "zod";
export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 200;
export const newPasswordSchema = z.string()
    .min(PASSWORD_MIN_LENGTH, `新密码至少 ${PASSWORD_MIN_LENGTH} 位`)
    .max(PASSWORD_MAX_LENGTH, `新密码最多 ${PASSWORD_MAX_LENGTH} 位`);
export const accountCredentialsUpdateSchema = z.object({
    username: z.string().trim().min(1, "登录名不能为空").max(80, "登录名过长")
        .regex(/^[A-Za-z0-9_.-]+$/, "登录名只能包含字母、数字、点、横线和下划线").optional(),
    newPassword: newPasswordSchema.optional(),
}).strict().refine((input) => input.username !== undefined || input.newPassword !== undefined, "请填写需要修改的登录名或新密码");
